export default __webpack_public_path__ + "static/media/printer.132c4a76.png";